<template>
    <FormSection title="Face Sheet Comments" :full-height="false" :application-id="application">
        <template #content>
            <section class="d-flex flex-column px-4 py-2">
                <div class="form-group col-12">
                    <CommentInput
                        input-name="referral-comments"
                        placeholder="Enter Comments"
                        :max-length="2000"
                        :show-template-typeahead="true"
                        :show-template-dropdown="false"
                        :result="patientDetails.faceSheetComments"
                        v-on:resultUpdatedAppended="addNewCommentAppend"
                        v-on:resultUpdated="commentUpdated"
                        :application="application"
                    />
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script src="./FacesheetComments.ts"></script>
